import axios, { AxiosError } from "axios";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { forgotPassword } from "src/redux/api/_admin.api";

type FormData = {
  email: string;
};

const ForgotPassword = () => {
  const form = useForm<FormData>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (values: FormData) => {
    if(values.email) {
      setLoading(true);
      try {
        const response = await forgotPassword(values.email);

        if(response.message.toLowerCase() === "success") {
          toast.success("Email sent!");
          navigate('/reset-password');
        }
      } catch (error: unknown) {
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          console.log(error)
          console.log(error.response?.data.message);

          if (axiosError.response) {
            toast.error(error.response?.data.message);
          }
        } else {
          toast.error("Failed to sent Email!");
          console.log(error);
        }
      } finally {
        setLoading(false);
      }
    } else {
      toast.warning("Please Enter Your Email!");
    }
  };

  return (
    <div className="">
      <div className="mt-40 flex flex-col justify-center items-center">
        <div className="w-[400px]">
          <h1 className="text-xl font-semibold my-3">
            Enter Your Email to Reset Your Password
          </h1>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div>
              <input
                type="text"
                placeholder="Enter Your Valid Email Address"
                className="input w-full focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-blue-300 ring-1 ring-gray-300 transition-colors"
                {...form.register("email", { required: true })}
              />
            </div>
            <div className="my-8 flex items-center justify-center">
              <button className="btn bg-blue-400 text-lg text-white hover:text-blue-500 transition-colors" type="submit">
                { loading ? <span className="loading loading-dots loading-xl size-12 text-white"></span> : <span>Send Email</span>}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
